module.exports = __webpack_public_path__ + "static/5-7be1f9c152db3ee647940e699a125397.jpg";